import { Component, OnInit, OnDestroy } from '@angular/core';
import { VendorService } from './../../../services/vendor.service';
import { DataService } from './../../../services/data.service';

@Component({
  selector: 'app-my-vendor',
  templateUrl: './my-vendor.component.html',
  styleUrls: ['./my-vendor.component.scss']
})
export class MyVendorComponent implements OnInit, OnDestroy {
  public vendorName = '';
  private alive = true;
  private userInfo: any;
  constructor(private datasvc: DataService) {
    this.userInfo = this.datasvc.userDisplayInfo;
    this.vendorName = this.userInfo.VendorName;
    console.log(this.vendorName);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.alive = false;
  }

  IsClientDetailsEnabled() {
    return this.userInfo.IsCoverageSearchEnabled;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/my-vendor.component.ts